export default __webpack_public_path__ + "static/media/mark_5.8f0f3c5f.png";